<template>
    <div class="row">
        <div class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group col-sm-8">
            <select class="select2" :multiple="isMultiple" :class="{'is-invalid': errors.has(name)}" :id="id" :name="name" :value="value"
                    v-validate="getValidators" :data-vv-as="label">
            </select>
            <div class="invalid-feedback">
                {{ errors.first(name) }}
            </div>
        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    import select2 from 'select2'
    import AppHelper from "../../helper";

    export default {
        mixins: [formElementMixin],

        props: {
            picklistValues: {},
            type: {default: 'picklist'}
        },

        computed: {
            options() {
                var options = this.picklistValues
                var filteredOptions = []

                $.each(options, function(key, value){
                    filteredOptions.push({id: key, text: value})
                })

                return filteredOptions
            },

            isMultiple() {
                if(this.type == 'multipicklist'){
                    return true;
                }

                return false;
            },

            getFormattedValue(){
                if(this.value != '' && this.value.indexOf(' |##| ') > -1){
                    return this.value.split(' |##| ')
                }

                return this.value
            },

            element() {
                return $('select.select2', this.$el)
            }
        },

        mounted() {
            var vm = this
            this.element.select2({
                dropdownAutoWidth: true,
                width: '100%',
                data: vm.options
            }).val(this.getFormattedValue).trigger('change').on('change', function(){
                vm.$emit('input', this.value)
            })
        },

        watch: {
            value: function (value) {
                // update value
                this.element.val(value).trigger('change')
            },
            options: function (options) {
                // update options
                this.element.empty().select2({ data: options })
            }
        },

        destroyed() {
            this.element.off().select2('destroy')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form_elements/Picklist.vue